"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const eventTypes = [{
  title: "Corporate Galas",
  description: "Sophisticated soul and timeless R&B for high-profile brand activations and corporate retreats.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1605600/img/luxury_corporate_gala_performance.png",
  bgClass: "bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1605600/img/luxury_corporate_gala_performance.png)]",
  link: "#",
  className: "col-span-full",
  linkClassName: "absolute inset-0 z-20 !bg-[url(https://prime-rhino.10web.cloud/wp-content/uploads/2026/03/image_9pkcjehj.jpg)] absolute inset-0 z-20 !bg-[url(https://prime-rhino.10web.cloud/wp-content/uploads/2026/03/Capture2.jpg)] absolute inset-0 z-20 !bg-[url(https://prime-rhino.10web.cloud/wp-content/uploads/2026/03/Capture2.jpg)] absolute inset-0 z-20 !bg-[url(https://prime-rhino.10web.cloud/wp-content/uploads/2026/03/SSOfficialLogo-version-2.png)] absolute inset-0 z-20 !bg-[url(https://prime-rhino.10web.cloud/wp-content/uploads/2026/03/Capture2.jpg)] absolute inset-0 z-20 !bg-[url(https://prime-rhino.10web.cloud/wp-content/uploads/2026/03/Capture2.jpg)] absolute inset-0 z-20 !bg-[url(https://prime-rhino.10web.cloud/wp-content/uploads/2026/03/Capture2.jpg)] absolute inset-0 z-20 !bg-[url(https://prime-rhino.10web.cloud/wp-content/uploads/2026/03/Capture2.jpg)] absolute inset-0 z-20 !bg-[url(https://prime-rhino.10web.cloud/wp-content/uploads/2026/03/Capture2.jpg)] absolute inset-0 z-20 !bg-[url(https://prime-rhino.10web.cloud/wp-content/uploads/2026/03/Capture2.jpg)] absolute inset-0 z-20 !bg-[url(https://prime-rhino.10web.cloud/wp-content/uploads/2026/03/Capture2.jpg)]"
}];
export default function SignatureEventTypes() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="93106" id="tailored-musical-experiences" className="dark bg-background text-foreground py-24 px-0 overflow-hidden">
      <div className="w-full mx-auto">
        <div ref={headerRef} className={`mb-16 px-4 sm:px-6 lg:px-8 max-w-3xl transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-6xl font-serif font-light tracking-tight mb-6 text-foreground">
            Exquisite <span className="text-secondary italic">Live Performances</span>
          </h2>
          <p className="text-lg md:text-xl text-foreground/70 font-sans max-w-2xl">
            From intimate soul sessions to high-energy R&B galas, Synergy Sound brings the heartbeat of Los Angeles to your most prestigious celebrations.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-3 auto-rows-[400px] md:auto-rows-[500px] gap-0 transition-all duration-1000 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {eventTypes.map((event, i) => <div key={event.title} data-index={i} className={`group relative overflow-hidden bg-card transition-all duration-700 ${event.className}`}>
              <div className={`absolute inset-0 bg-cover bg-center brightness-75 contrast-110 transition-all duration-1000 ease-in-out group-hover:scale-110 group-hover:brightness-90 ${event.bgClass}`} />
              
              <div className="absolute inset-0 bg-gradient-to-t from-background via-background/20 to-transparent opacity-90 transition-opacity duration-700 group-hover:opacity-70" />

              <Link to={event.link} className={`${event.linkClassName || ""} absolute inset-0 z-20`}>
                <span className="sr-only">Explore {event.title}</span>
              </Link>

              <div className="absolute bottom-12 left-4 sm:left-8 right-4 sm:right-auto md:max-w-[600px] z-10">
                <div className="bg-background/60 backdrop-blur-md border-[0.5px] border-secondary/20 rounded p-8 transition-transform duration-700 ease-out group-hover:-translate-y-4">
                  <h3 className="text-3xl md:text-5xl font-serif font-medium text-foreground mb-4">
                    {event.title}
                  </h3>
                  <p className="text-foreground/80 text-base md:text-lg font-sans mb-6 line-clamp-3">
                    {event.description}
                  </p>
                  <div className="flex items-center text-secondary font-mono font-medium text-sm uppercase tracking-[0.2em]">
                    <span>Learn More</span>
                    <ArrowRight className="ml-2 size-5 transition-transform duration-500 group-hover:translate-x-3" />
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}